import React from "react";
import Hero from "@/components/Common/Hero";
import RolexWatchesGrid from "@/components/RolexWatches/Watches";
import { SliceZone } from "@prismicio/react";
import ContactMB from "@/components/Common/ContactUS";
import Breadcrumbs from "@/components/Common/Breadcrumbs";
import WatchSideBar from "@/components/RolexWatches/Watches/components/WatchSideBar";
import { useRouter } from "next/router";

const SingleWatchPage = ({
  pageData,
  components,
  commonComponents,
  watches,
}) => {
  const router = useRouter();
  const showWatchSideBar = router.asPath.includes("rolex-watch-buyers");

  return (
    <div className="overflow-hidden">
      <Hero
        caption={pageData?.hero_caption || ""}
        title={pageData?.hero_title || ""}
        sideImage={pageData?.hero_side_image?.url || ""}
        sideImageMobile={pageData?.hero_mobile_side_image?.url || ""}
        backgroundImage={pageData?.hero_background_image}
        description={pageData?.hero_description || ""}
        features={pageData?.hero_feature_list || []}
        opacity={false}
        page={`${pageData?.hero_title}`}
      />
      <Breadcrumbs />
      <div className="watches_content_with_interlinks_wrapper">
        {showWatchSideBar && (
          <div className="interlinks_wrapper">
            <WatchSideBar
              title={commonComponents?.luxury_watches_menu_title}
              links={commonComponents?.luxury_watches_links}
            />
          </div>
        )}

        <RolexWatchesGrid
          title={pageData?.main_title || ""}
          description={pageData?.main_description || []}
          models={pageData?.watch_models || ""}
          watches={watches || []}
          commonComponents={commonComponents}
          styles={showWatchSideBar ? "rolex-watch-buyers-content" : ""}
        />
      </div>
      <ContactMB data={commonComponents} call={true} title_fw_style="fw-bold" />
      {pageData?.slices2 && (
        <SliceZone slices={pageData?.slices2} components={components} />
      )}
      <div style={{ height: "40px" }}></div>
    </div>
  );
};

export default SingleWatchPage;
